import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { IArpMedia } from '../../../../features/arp-registry/ArpMedia'
import ArpRegistry from '../../../../features/arp-registry/ArpRegistry'
import { useAuth } from '../../../hooks/useAuth'
import useUserFavoritedMedia from '../../../hooks/useUserFavoritedMedia'
import { userIsLoggedIn } from '../../core/Authentication'
import CenteredLoadingAnimation from '../../core/CenteredLoadingAnimation'
import { Column, Row, StyledScrollable } from '../../core/Components'
import { StudioTab } from '../controls/common'
import Search from '../controls/Search'
import { DrawerHeader } from './ActivityBarComponents'
import { SongItem } from './ArtistMediaDropdown'
import SampleList from './sample-list'
import StemItem from './StemItem'

export const FavoriteTabs = {
  SONGS: 0,
  STEMS: 1,
  SAMPLES: 2
}

const FavoritesSelector = () => {
  const { user } = useAuth()
  const [query, setQuery] = useState<string>('')
  const [selectedTab, setSelectedTab] = useState<number>(FavoriteTabs.SONGS)
  const { songsLoaded, stemsLoaded, samplesLoaded, songData } = useUserFavoritedMedia()

  return (
    <Column
      className="h-100 w-100 studio-text-sm"
      style={{
        overflow: 'hidden',
        alignItems: 'stretch'
      }}
    >
      <DrawerHeader>Favorites</DrawerHeader>
      <Search
        query={query}
        placeholder="Search for favorites"
        setQuery={setQuery}
        style={{ marginTop: '0', marginBottom: '10px' }}
      />
      {userIsLoggedIn(user) && (
        <>
          <Row>
            <StudioTab
              onClick={() => setSelectedTab(FavoriteTabs.SONGS)}
              active={selectedTab === FavoriteTabs.SONGS}
            >
              Songs
            </StudioTab>
            <StudioTab
              onClick={() => setSelectedTab(FavoriteTabs.STEMS)}
              active={selectedTab === FavoriteTabs.STEMS}
            >
              Stems
            </StudioTab>
            <StudioTab
              onClick={() => setSelectedTab(FavoriteTabs.SAMPLES)}
              active={selectedTab === FavoriteTabs.SAMPLES}
            >
              Samples
            </StudioTab>
          </Row>
          <Column className="fs-14" style={{ paddingTop: '8px', flex: 1, overflowY: 'auto' }}>
            <StyledScrollable css={{ paddingLeft: '6px', paddingRight: '6px' }}>
              {ArpRegistry.readyForStudioUse &&
                ((selectedTab === FavoriteTabs.SONGS &&
                  (songsLoaded ? (
                    songData &&
                    songData
                      .filter(
                        (song) =>
                          song &&
                          (query === '' ||
                            song.metadata.title.toLowerCase().includes(query.toLowerCase()) ||
                            song.user.displayName.toLowerCase().includes(query.toLowerCase()))
                      )
                      .map((song, index: number, { length }) => (
                        <SongItem
                          songData={song}
                          key={song.id}
                          hideBottomBorder={index + 1 === length}
                        />
                      ))
                  ) : (
                    <CenteredLoadingAnimation light />
                  ))) ||
                  (selectedTab === FavoriteTabs.STEMS &&
                    (stemsLoaded ? (
                      user.favorite_stems &&
                      user.favorite_stems
                        .map((stemId) => ArpRegistry.retrieveFromCache(stemId))
                        .filter(
                          (stem) =>
                            stem &&
                            (query === '' ||
                              stem.metadata.title.toLowerCase().includes(query.toLowerCase()) ||
                              stem.artist.toLowerCase().includes(query.toLowerCase()))
                        )
                        .map((stem) => <StemItem stem={stem} key={stem.id} />)
                    ) : (
                      <CenteredLoadingAnimation light />
                    ))) ||
                  (selectedTab === FavoriteTabs.SAMPLES &&
                    (samplesLoaded ? (
                      user.favorite_samples && (
                        <SampleList
                          samples={user.favorite_samples
                            .map((sample_id) => ArpRegistry.retrieveFromCache(sample_id))
                            .filter(
                              (sample: IArpMedia) =>
                                query === '' ||
                                sample.metadata.title.toLowerCase().includes(query.toLowerCase()) ||
                                sample.user.displayName.toLowerCase().includes(query.toLowerCase())
                            )
                            .map((sample: IArpMedia) => sample)}
                          defaultIsActive
                          defaultIsOpen
                        />
                      )
                    ) : (
                      <CenteredLoadingAnimation light />
                    ))))}
            </StyledScrollable>
          </Column>
        </>
      )}
    </Column>
  )
}

export default observer(FavoritesSelector)
